import { lazy } from 'react';

const MarginTrading = lazy(() => import(/* webpackChunkName: "mt-container" */ './Container'));
const MTOnboarding = lazy(() => import(/* webpackChunkName: "mt-onboarding" */ './Onboarding'));
const MTActivation = lazy(() => import(/* webpackChunkName: "mt-activation" */ './Activation'));
const MTActivationStatus = lazy(() => import(/* webpackChunkName: "mt-activation-status" */ './ActivationStatus'));

export { MarginTrading, MTOnboarding, MTActivation, MTActivationStatus };
